import React from 'react';

const AvatarShop = () => {
    return (
        <div className="avatar-section">
            <h2>🛍️ Avatar Shop</h2>
            <p>Shop items by rarity and spend your tokens or echoes!</p>
        </div>
    );
};

export default AvatarShop;